"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ButtonDoSync = /** @class */ (function (_super) {
    __extends(ButtonDoSync, _super);
    function ButtonDoSync(props) {
        return _super.call(this, props) || this;
    }
    ButtonDoSync.prototype.buttonClick = function () {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };
    ButtonDoSync.prototype.render = function () {
        return (React.createElement(antd_1.Tooltip, { placement: "bottom", title: React.createElement("div", null, this.props.hint), trigger: "hover" },
            React.createElement(antd_1.Button, { icon: "fork", ghost: true, type: "danger", style: { margin: "2px", marginBottom: "7px" }, onClick: this.buttonClick.bind(this), disabled: this.props.disabled })));
    };
    return ButtonDoSync;
}(React.Component));
exports.default = ButtonDoSync;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/buttons/ButtonDoSync.tsx
// module id = 775
// module chunks = 0